export class TwoSubstitution {
  constructor({ animate, preview, update, animateOff, clearPreview }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.clearPreview = clearPreview;
    this.name = "TwoSubstitution";
    this.scene = "Two Substitution";
    this.data = [];
    this.page = 1;
  }

  preview({ description, options }) {
    this.options = options;
    this.onAir = false;
    this.data = [];
    this.options = options;
    let playerIndex = 0;

    this.createSub({
      playerOn: options.players_on[0],
      playerOff: options.players_off[0],
      index: 1,
    });

    this.createSub({
      playerOn: options.players_on[1],
      playerOff: options.players_off[1],
      index: 3,
    });

    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Subtitle",
      value: {
        text: "",
      },
    });

    this.data.push({
      name: "Team Code",
      value: {
        text: options.team?.code,
      },
    });

    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name || "",
      },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge || "",
      },
    });

    let kit_bg =
      options?.game?.home_team?._id === options.team?._id
        ? options.game?.home_team_kit + "_kit_bg"
        : options.game?.away_team_kit + "_kit_bg";

    let kit_text =
      options?.game?.home_team?._id === options.team?._id
        ? options.game?.home_team_kit + "_kit_text"
        : options.game?.away_team_kit + "_kit_text";

    this.data.push({
      name: "Team Type",
      value: {
        text:
          options?.game?.home_team?._id === options.team?._id
            ? "home"
            : options?.game?.away_team?._id === options.team?._id
            ? "away"
            : "",
      },
    });

    this.data.push({
      name: "Team Kit BG Colour",
      value: {
        colour: options.team?.variables?.[kit_bg] || "",
      },
    });
    this.data.push({
      name: "Team Kit Text Colour",
      value: {
        colour: options.team?.variables?.[kit_text] || "",
      },
    });

    this.sendPreview(this.scene, 500, this.data, "IN", description);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
    if (this.page === 1) {
      this.page = 2;
      this.preview({ options: this.options });
    }
  }
  animateOff({ options }) {
    this.clearPreview(this.scene);
    this.page = 1;
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }

  createSub({ playerOn, playerOff, index }) {
    this.data.push({
      name: "Shirt Number " + index,
      value: {
        text:
          playerOn?.squad?.shirt_number ??
          playerOn?.squad?.opta_shirt_number ??
          "",
      },
    });
    this.data.push({
      name: "First Name " + index,
      value: {
        text:
          playerOn?.squad?.player.first_name ??
          playerOn?.squad?.player.opta_first_name ??
          "",
      },
    });
    this.data.push({
      name: "Last Name " + index,
      value: {
        text:
          playerOn?.squad?.player.last_name ??
          playerOn?.squad?.player?.opta_last_name ??
          "",
      },
    });
    this.data.push({
      name: "First Name Uppercase " + index,
      value: {
        text:
          playerOn?.squad?.player.first_name_upper ??
          playerOn?.squad?.player?.opta_first_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase " + index,
      value: {
        text:
          playerOn?.squad?.player.last_name_upper ??
          playerOn?.squad?.player?.opta_last_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Full Name " + index,
      value: {
        text:
          (playerOn?.squad?.player.first_name ??
            playerOn?.squad?.player.opta_first_name ??
            "") +
          " " +
          (playerOn?.squad?.player.last_name ??
            playerOn?.squad?.player.opta_last_name ??
            ""),
      },
    });
    this.data.push({
      name: "Shirt Number " + (index + 1),
      value: {
        text:
          playerOff?.squad?.shirt_number ??
          playerOff?.squad?.opta_shirt_number ??
          "",
      },
    });
    this.data.push({
      name: "First Name " + (index + 1),
      value: {
        text:
          playerOff?.squad?.player.first_name ??
          playerOff?.squad?.player.opta_first_name ??
          "",
      },
    });
    this.data.push({
      name: "Last Name " + (index + 1),
      value: {
        text:
          playerOff?.squad?.player.last_name ??
          playerOff?.squad?.player.opta_last_name ??
          "",
      },
    });
    this.data.push({
      name: "First Name Uppercase " + (index + 1),
      value: {
        text:
          playerOff?.squad?.player.first_name_upper ??
          playerOff?.squad?.player.opta_first_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase " + (index + 1),
      value: {
        text:
          playerOff?.squad?.player.last_name_upper ??
          playerOff?.squad?.player.opta_last_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Full Name " + (index + 1),
      value: {
        text:
          (playerOff?.squad?.player.first_name ??
            playerOff?.squad?.player.opta_first_name ??
            "") +
          " " +
          (playerOff?.squad?.player.last_name ??
            playerOff?.squad?.player.opta_last_name ??
            ""),
      },
    });
  }
}
